const useClassName = (...classes: (boolean | string | null | undefined)[]) =>
  classes.filter(i => typeof i === 'string' && i.length).join(' ');

export default useClassName;
